<template>
  <div>
    <b-modal
      v-if="system_update && system_update.status == 1"
      id="system-update"
      no-close-on-backdrop
      hide-footer
      modal-class="system-update-modal"
      size="lg"
      hide-header-close
      hide-header
      centered
    >
      <div class="update-content">
        <!-- Header Card -->
        <div class="update-header-card">
          <div class="header-icon">
            <i class="fas fa-bell"></i>
          </div>
          <div class="header-info">
            <h3 class="update-title">Nova Atualização Disponível</h3>
            <p class="update-message">{{ system_update.message }}</p>
          </div>
        </div>

        <!-- Date Info -->
        <div class="date-card">
          <div class="date-icon">
            <i class="fas fa-calendar-alt"></i>
          </div>
          <div class="date-info">
            <span class="date-label">Data da Atualização</span>
            <span class="date-value">{{
              formatDate(system_update.date, false)
            }}</span>
          </div>
        </div>

        <!-- Features List -->
        <div v-if="system_update.list" class="features-section">
          <div class="features-header">
            <div class="features-icon">
              <i class="fas fa-plus"></i>
            </div>
            <h4 class="features-title">Novas Funcionalidades</h4>
          </div>

          <div class="features-list">
            <div
              v-for="(topic, key) in JSON.parse(system_update.list)"
              :key="key"
              class="feature-item"
            >
              <div class="feature-number">
                <span>{{ key + 1 }}</span>
              </div>
              <div class="feature-content">
                <p class="feature-text">{{ topic.message }}</p>
              </div>
              <div class="feature-check">
                <i class="fas fa-check-circle"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Actions -->
        <div class="update-footer">
          <div class="footer-info">
            <i class="fas fa-info-circle mr-2"></i>
            <span>Aproveite as novidades e melhore sua experiência!</span>
          </div>
          <v-btn
            class="btn-close-update"
            @click="$bvModal.hide('system-update')"
          >
            <i class="fas fa-check mr-2"></i>
            Entendi
          </v-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { formatDate } from "../../lib/format";

export default {
  name: "SystemUpdate",
  data() {
    return {
      system_update: undefined,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    retrieve() {
      let system_update = sessionStorage.getItem("system_update");
      if (system_update) {
        this.system_update = JSON.parse(system_update);
      }
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.system-update-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  overflow: hidden;
}

.system-update-modal >>> .modal-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  border-bottom: none !important;
  padding: 24px 32px !important;
  border-radius: 0 !important;
}

.system-update-modal >>> .modal-body {
  padding: 0 !important;
  background: #f8fafc;
}

.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  color: white !important;
  font-family: "WorkSans-SemiBold", sans-serif;
  width: 100%;
}

.rotating-icon {
  animation: rotate 2s linear infinite;
  color: white;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Content Styling */
.update-content {
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Card */
.update-header-card {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  border: 1px solid #7dd3fc;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 4px 15px rgba(14, 165, 233, 0.15);
}

.header-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(14, 165, 233, 0.3);
}

.header-info {
  flex: 1;
}

.update-title {
  font-size: 20px;
  font-weight: 600;
  color: #0c4a6e;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.update-message {
  font-size: 15px;
  color: #075985;
  margin: 0;
  line-height: 1.6;
}

/* Date Card */
.date-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.date-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  flex-shrink: 0;
}

.date-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.date-label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.date-value {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

/* Features Section */
.features-section {
  background: white;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.features-header {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #f59e0b;
}

.features-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
}

.features-title {
  font-size: 18px;
  font-weight: 600;
  color: #92400e;
  margin: 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

/* Features List */
.features-list {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  position: relative;
}

.feature-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.feature-number {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}

.feature-content {
  flex: 1;
}

.feature-text {
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.6;
  font-weight: 500;
}

.feature-check {
  color: #10b981;
  font-size: 20px;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.feature-item:hover .feature-check {
  opacity: 1;
}

/* Footer */
.update-footer {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.footer-info {
  display: flex;
  align-items: center;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
}

.footer-info i {
  color: #0f65b0;
}

.btn-close-update {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 12px 28px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
  font-size: 14px !important;
}

.btn-close-update:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .update-content {
    padding: 20px;
    gap: 20px;
  }

  .system-update-modal >>> .modal-header {
    padding: 20px 24px !important;
  }

  .modal-title-modern {
    font-size: 18px;
  }

  .update-header-card {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }

  .header-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }

  .update-title {
    font-size: 18px;
  }

  .update-message {
    font-size: 14px;
  }

  .date-card {
    flex-direction: column;
    text-align: center;
    padding: 16px;
  }

  .date-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .date-value {
    font-size: 16px;
  }

  .features-header {
    padding: 16px 20px;
  }

  .features-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .features-title {
    font-size: 16px;
  }

  .features-list {
    padding: 6px;
  }

  .feature-item {
    padding: 12px;
  }

  .feature-number {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .feature-text {
    font-size: 13px;
  }

  .update-footer {
    flex-direction: column;
    gap: 16px;
    padding: 16px 20px;
    text-align: center;
  }

  .footer-info {
    justify-content: center;
    font-size: 13px;
  }

  .btn-close-update {
    width: 100%;
    padding: 14px 24px !important;
  }
}

@media (max-width: 480px) {
  .update-content {
    padding: 16px;
    gap: 16px;
  }

  .system-update-modal >>> .modal-header {
    padding: 16px 20px !important;
  }

  .modal-title-modern {
    font-size: 16px;
  }

  .update-header-card {
    padding: 16px;
  }

  .update-title {
    font-size: 16px;
  }

  .update-message {
    font-size: 13px;
  }

  .date-card {
    padding: 14px;
  }

  .features-header {
    padding: 14px 16px;
  }

  .features-title {
    font-size: 15px;
  }

  .feature-item {
    padding: 10px;
    gap: 12px;
  }

  .feature-number {
    width: 26px;
    height: 26px;
    font-size: 11px;
  }

  .feature-text {
    font-size: 12px;
  }

  .feature-check {
    font-size: 18px;
  }
}

/* Animation for feature items */
.feature-item {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.feature-item:nth-child(1) {
  animation-delay: 0.1s;
}
.feature-item:nth-child(2) {
  animation-delay: 0.2s;
}
.feature-item:nth-child(3) {
  animation-delay: 0.3s;
}
.feature-item:nth-child(4) {
  animation-delay: 0.4s;
}
.feature-item:nth-child(5) {
  animation-delay: 0.5s;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>